<template>
    <div>
        <div class="row">
            <div class="col px-0">
                <div class="jumbotron jumbotron-fluid">
                    <div class="container text-center">
                        <h1 class="display-4">Directorio</h1>
                        <p class="lead">Busca tus animes favoritos</p>
                    </div>
                    <div class="row">
                        <div class="offset-2 col-10">
                            <div class="row">
                                <div class="col-9">
                                    <input type="text" class="form-control" v-model="keyword"
                                           placeholder="Qué anime buscas?">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-3">
                                    <label>Género:</label>
                                    <select id="genero" class="form-control" v-model="genre">
                                        <option value="">Selecciona un género</option>
                                        <option value="1">Acción</option>
                                        <option value="11">Artes Marciales</option>
                                        <option value="21">Aventuras</option>
                                        <option value="31">Carreras</option>
                                        <option value="2">Ciencia Ficción</option>
                                        <option value="12">Comedia</option>
                                        <option value="22">Demencia</option>
                                        <option value="32">Demonios</option>
                                        <option value="3">Deportes</option>
                                        <option value="13">Drama</option>
                                        <option value="23">Ecchi</option>
                                        <option value="33">Escolares</option>
                                        <option value="4">Espacial</option>
                                        <option value="14">Fantasía</option>
                                        <option value="24">Harem</option>
                                        <option value="34">Historico</option>
                                        <option value="5">Infantil</option>
                                        <option value="43">Isekai</option>
                                        <option value="15">Josei</option>
                                        <option value="25">Juegos</option>
                                        <option value="41">Latino y Castellano</option>
                                        <option value="35">Magia</option>
                                        <option value="6">Mecha</option>
                                        <option value="16">Militar</option>
                                        <option value="26">Misterio</option>
                                        <option value="36">Música</option>
                                        <option value="7">Parodia</option>
                                        <option value="17">Policía</option>
                                        <option value="27">Psicológico</option>
                                        <option value="37">Recuentos de la vida</option>
                                        <option value="8">Romance</option>
                                        <option value="18">Samurai</option>
                                        <option value="28">Seinen</option>
                                        <option value="38">Shoujo</option>
                                        <option value="9">Shounen</option>
                                        <option value="19">Sobrenatural</option>
                                        <option value="29">Superpoderes</option>
                                        <option value="39">Suspenso</option>
                                        <option value="10">Terror / Gore</option>
                                        <option value="20">Vampiros</option>
                                        <option value="30">Yaoi</option>
                                        <option value="4">Yuri</option>
                                    </select>
                                </div>
                                <div class="col-3">
                                    <label>Tipo:</label>
                                    <select id="tipo" class="form-control" v-model="type">
                                        <option value="">Selecciona un tipo</option>
                                        <option value="Anime">Anime</option>
                                        <option value="OVA">OVA</option>
                                        <option value="Película">Pelicula</option>
                                        <option value="Pro">Pro</option>
                                    </select>
                                </div>
                                <div class="col-3">
                                    <label>Estado:</label>
                                    <select id="estado" class="form-control" v-model="status">
                                        <option value="">Selecciona una opción</option>
                                        <option value="En emisión">En emisión</option>
                                        <option value="Finalizado">Finalizado</option>
                                        <option value="Próximamente">Próximamente</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-3">
                                    <label>Orden:</label>
                                    <select id="orden" class="form-control" v-model="orderBy">
                                        <option value="Fecha (Menor a Mayor)">Fecha (Menor a Mayor)</option>
                                        <option value="Recientemente vistos por otros">Recientemente vistos por otros
                                        </option>
                                        <option value="Fecha (Mayor a Menor)">Fecha (Mayor a Menor)</option>
                                        <option value="A-Z">A-Z</option>
                                        <option value="Más Visitado">Más Visitado</option>
                                        <option value="Z-A">Z-A</option>
                                        <option value="Mejor Calificación">Mejor Calificación</option>
                                        <option value="Peor Calificación">Peor Calificación</option>
                                        <option value="Últimos Agregados en app">Últimos Agregados en app</option>
                                        <option value="Primeros Agregados en app">Primeros Agregados en app</option>
                                    </select>
                                </div>
                                <div class="col-3">
                                    <label>Año:</label>
                                    <select id="año" class="form-control" v-model="year">
                                        <option value="">Selecciona un año</option>
                                        <option v-for="(year,index) in years" :value="year" v-text="year"
                                                :key="index"></option>
                                    </select>
                                </div>
                                <div class="col-3">
                                    <label>Letra:</label>
                                    <select id="letra" class="form-control" v-model="letter">
                                        <option value="Todas">Todas</option>
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                        <option value="D">D</option>
                                        <option value="E">E</option>
                                        <option value="F">F</option>
                                        <option value="G">G</option>
                                        <option value="H">H</option>
                                        <option value="I">I</option>
                                        <option value="J">J</option>
                                        <option value="K">K</option>
                                        <option value="L">L</option>
                                        <option value="M">M</option>
                                        <option value="N">N</option>
                                        <option value="O">O</option>
                                        <option value="P">P</option>
                                        <option value="Q">Q</option>
                                        <option value="R">R</option>
                                        <option value="S">S</option>
                                        <option value="T">T</option>
                                        <option value="U">U</option>
                                        <option value="V">V</option>
                                        <option value="W">W</option>
                                        <option value="X">X</option>
                                        <option value="Y">Y</option>
                                        <option value="Z">Z</option>
                                        <option value="0">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value=".">.</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="offset-3 col-3">
                                    <button class="btn btn-success btn-block" @click="search">BUSCAR</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-3" v-show="chunks.length && !loadingState">
            <div class="col-10 offset-1">
                <div class="row mb-5" v-for="(chunk, index) in chunks" :key="index">
                    <div class="col-md-3 card-container" v-for="(episode, index) in chunk" :key="index">
                        <b-card-group deck>
                            <b-card class="shadow-lg" border-variant="secondary">
                                <!--<b-card-text>Visitas: {{ reduceCounter(episode.visitas) }}</b-card-text>-->
                                <router-link :to="'anime/'+episode.id">
                                    <b-card-img
                                            :src="thumbsPrefix + episode.img_url"
                                            :alt="episode.nombre" top></b-card-img>
                                </router-link>
                                <b-card-text>
                                    <router-link :to="'anime/'+episode.id" class="font-weight-bold">{{ episode.nombre
                                        }}
                                    </router-link>
                                </b-card-text>
                                <b-button-group size="sm">
                                    <b-button variant="outline-danger"
                                              @click="toggleFavorite(episode)"><i class="fa fa-heart"></i>
                                    </b-button>
                                    <b-button variant="outline-secondary"
                                              @click="soon"><i class="fa fa-clock-o"></i>
                                    </b-button>
                                    <b-button variant="outline-secondary"
                                              @click="soon"><i
                                            class="fa fa-bookmark"></i>
                                    </b-button>
                                </b-button-group>
                            </b-card>
                        </b-card-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-3" v-show="!chunks.length && !loadingState">
            <div class="offset-2 col-8">
                <div class="row">
                    <div class="col-12"><h1 class="text-center">No se encontraron resultados</h1></div>
                    <div class="offset-4 col-4 mt-3">
                        <img src="../assets/glass.png" width="100%">
                    </div>
                </div>
            </div>
        </div>

        <div style="margin-top: 200px" v-show="loadingState">
            <ring-loader></ring-loader>
            <h1>Cargando...</h1>
        </div>
    </div>
</template>

<script>
    import {http} from './../misc/http';
    import {RingLoader} from 'vue-spinners-css';
    import Swal from 'sweetalert2';
    import moment from "moment";

    export default {
        name: "directory",
        components: {
            RingLoader
        },
        data() {
            return {
                APP_URL: 'http://legion-dashboard.test',
                WEBAPP_URL: 'https://legion-anime.test',
                CONST_CHUNK_SIZE: 4,
                chunks: [],
                keyword: '',
                genre: '',
                type: '',
                status: '',
                orderBy: 'Fecha (Menor a Mayor)',
                year: '',
                letter: 'Todas',
                loadingState: true,
                years: [],
                myToggle: true,
                spaces: [],
                thumbsPrefix: '',
            }
        },
        created() {
            Array.prototype.chunk = function (n) {
                if (!this.length) {
                    return [];
                }
                return [this.slice(0, n)].concat(this.slice(n).chunk(n));
            };
        },
        mounted() {
            this.setThumbPrefix();
            for (let i = 1981; i <= new Date().getFullYear(); i++) {
                this.years.push(i);
            }
            if (this.$route.query.hasOwnProperty('keyword')) {
                this.keyword = this.$route.query.keyword;
            }
            setTimeout(() => {
                this.search();
            }, 100);
        },
        methods: {
            setThumbPrefix() {
                this.thumbsPrefix = this.shuffle(this.getSpaces())[0];
            },
            getSpaces() {
                let spaces = process.env.VUE_APP_SPACES;
                spaces = spaces.split(',').map(space => {
                    return `https://la-space-${space}.sfo2.cdn.digitaloceanspaces.com/`;
                });
                //spaces.push('https://la-space.sfo2.cdn.digitaloceanspaces.com/');
                return spaces;
            },
            setGrid(episodes) {
                this.chunks = episodes.chunk(this.CONST_CHUNK_SIZE);

                if (!this.chunks.length) {
                    Swal.fire({
                        icon: 'success',
                        title: 'No se encontraron resultados',
                        message: 'Intenta otra búsqueda',
                    });
                }
            },
            reduceCounter(total) {
                if (total > 1000) {
                    return (total / 1000).toFixed(1) + "K";
                }

                return total;
            },
            async search() {
                this.toggleLoading(true);
                let query = {
                    limit: 32,
                    search: this.keyword,
                    genre: this.genre,
                    type: this.type,
                    status: this.status,
                    orderBy: this.orderBy,
                    year: this.year,
                    letter: this.letter,
                };

                let animes = localStorage.getItem(JSON.stringify(query));
                let animes_expires_at = localStorage.getItem(JSON.stringify(query) + '_expires_at');

                if (animes === null || (animes && moment().isAfter(animes_expires_at))) {
                    try {
                        const response = await http.post('/directory', {filter: query});
                        if (response.data.success) {
                            animes = response.data.response;
                        } else {
                            animes = [];
                        }
                        localStorage.setItem(JSON.stringify(query), JSON.stringify(animes));
                        localStorage.setItem(JSON.stringify(query) + '_expires_at', moment().add(24, 'hours'));
                    } catch (error) {
                        animes = [];
                        this.toggleLoading(false);
                        return;
                    }
                } else {
                    animes = JSON.parse(animes);
                }

                this.setGrid(this.onlyFreeContent(animes));
                this.toggleLoading(false);
            },
            toggleLoading(state) {
                this.loadingState = state;
            },
            onlyFreeContent(episodes) {
                let freeContent = [];
                episodes.forEach(episode => {
                    if (!episode.kind_content) {
                        freeContent.push(episode);
                    }
                });

                return freeContent;
            },
            async toggleFavorite(episode) {
                try {
                    const response = await http.post(`/anime/${episode.id}/favorite`);
                    Swal.fire({
                        icon: 'success',
                        title: response.data.message,
                        timer: 2000,
                    });
                    // eslint-disable-next-line no-empty
                } catch (error) {
                }
            },
            soon() {
                Swal.fire({
                    icon: 'info',
                    title: '¡Espera esta opción muy pronto!',
                    timer: 5000,
                });
            },
            getImageURL(img_url) {
                return this.shuffle(this.spaces)[0] + img_url;
            },
            imgUrlAlt(event) {
                event.target.src = "../assets/default.png";
            },
            shuffle(array) {
                return array.sort(() => Math.random() - 0.5);
            },
        }
    }
</script>

<style scoped>

</style>
